interface OptionButtonProps {
  label: string;
  emoji?: string;
  subtitle?: string;
  selected: boolean;
  onClick: () => void;
}

const OptionButton = ({ label, emoji, subtitle, selected, onClick }: OptionButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        w-full px-2 py-1 font-mono text-left border-2 font-bold text-sm
        ${
          selected
            ? 'bg-[#3cbe8c] text-white border-[#077f5d]'
            : 'bg-white text-[#1a1a1a] border-[#077f5d]'
        }
      `}
      style={{
        boxShadow: selected ? '4px 4px 0 #077f5d' : '3px 3px 0 #92bfad',
        transform: selected ? 'translate(-2px, -2px)' : 'translate(0, 0)',
      }}
      onMouseEnter={(e) => {
        if (selected) {
          e.currentTarget.style.boxShadow = '2px 2px 0 #077f5d';
          e.currentTarget.style.transform = 'translate(-2px, -2px)';
        } else {
          e.currentTarget.style.boxShadow = '2px 2px 0 #92bfad';
          e.currentTarget.style.transform = 'translate(-1px, -1px)';
        }
      }}
      onMouseLeave={(e) => {
        if (selected) {
          e.currentTarget.style.boxShadow = '4px 4px 0 #077f5d';
        } else {
          e.currentTarget.style.boxShadow = '3px 3px 0 #92bfad';
        }
        e.currentTarget.style.transform = 'translate(0, 0)';
      }}
    >
      <div className="flex items-center gap-3">
        {emoji && <span className="text-2xl">{emoji}</span>}
        <div className="flex-1">
          <div>{label}</div>
          {subtitle && (
            <div className={`text-xs ${selected ? 'text-white opacity-80' : 'text-[#077f5d]'}`}>
              {subtitle}
            </div>
          )}
        </div>
      </div>
    </button>
  );
};

export default OptionButton;
